import instance from "http/Manager";
import { headers } from "http/Settings";

export const get_characters = (page = 1) => {
  return instance.get(`/v1/mngr/characters`, { headers, params: { page } });
};

export const put_character_description = (data) => {
  return instance.put(`/v1/mngr/characters-description`, data, { headers });
};

export const post_characters = (data) => {
  return instance.post(`/v1/mngr/characters`, data, {
    headers: { ...headers, "Content-Type": "multipart/form-data" },
  });
};

export const put_characters = (data) => {
  return instance.put(`/v1/mngr/characters`, data, {
    headers: { ...headers, "Content-Type": "multipart/form-data" },
  });
};

export const delete_characters = (id) => {
  return instance.delete(`/v1/mngr/characters/${id}`, { headers });
};
